import React, {PureComponent} from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import lodashGet from 'lodash/get';
import isContentOverflowingElement from '@adsk/bim360-matrix-react-helpers/es/isContentOverflowingElement';
import Tooltip from '@adsk/bim360-matrix-react-tooltip';
import {stopPropagation} from '../../../utils/dom-helpers';

class IssueAttributesScrollableTooltipCell extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isHovered: false
    };

    this._setContainerRef = this._setContainerRef.bind(this);
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
  }

  componentWillUnmount() {
    if (this.hideTimeout) {
      delete this.hideTimeout;
    }
  }

  onMouseEnter() {
    if (!this.state.isHovered) {
      this.setState({isHovered: true});
    }
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
    }
  }

  onMouseLeave() {
    this.hideTimeout = setTimeout(() => {
      if (this.state.isHovered) {
        this.setState({isHovered: false});
      }
      delete this.hideTimeout;
    }, this.props.delay);
  }

  _setContainerRef(ref) {
    this.container = ref;
  }

  _renderOption(option) {
    return (
      <div
        className="IssueAttributesScrollableTooltipCell__tooltip-value"
        data-testid="IssueAttributesScrollableTooltipCell__tooltip-value"
        key={lodashGet(option, 'key', option)}
      >
        {option}
      </div>
    );
  }

  _renderTooltip() {
    const {options} = this.props;
    return options.length > 0 ? (
      <div
        className="IssueAttributesScrollableTooltipCell__tooltip-text"
        data-testid="IssueAttributesScrollableTooltipCell__tooltip-text"
        onClick={stopPropagation}
      >
        {options.map(option => this._renderOption(option))}
      </div>
    ) : null;
  }

  _renderContent() {
    const {options} = this.props;
    return options.length > 0 ? options.reduce((prev, curr) => [prev, ', ', curr]) : '-';
  }

  render() {
    const {container} = this.props;
    const {isHovered} = this.state;

    const isTruncated = isContentOverflowingElement(this.container);
    const showTooltip = isHovered && isTruncated;
    const className = cx('IssueAttributesScrollableTooltipCell');

    return (
      <div
        ref={this._setContainerRef}
        className={className}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
      >
        <Tooltip
          tooltipClassName="IssueAttributesScrollableTooltipCell__container"
          place={Tooltip.Places.RIGHT}
          content={this._renderTooltip()}
          container={container}
          show={showTooltip}
        >
          {this._renderContent()}
        </Tooltip>
      </div>
    );
  }
}

IssueAttributesScrollableTooltipCell.displayName = 'IssueAttributesScrollableTooltipCell';

IssueAttributesScrollableTooltipCell.defaultProps = {
  delay: 100
};

IssueAttributesScrollableTooltipCell.propTypes = {
  options: PropTypes.arrayOf(PropTypes.node),
  container: PropTypes.object.isRequired,
  delay: PropTypes.number
};

export default IssueAttributesScrollableTooltipCell;
